import React, { FC } from 'react';
import CookieConsent from 'react-cookie-consent';
import { useTranslation } from 'react-i18next';

import If from 'bundles/components/common/If';

const CookieConsentComponent = () => {
  const { t } = useTranslation();
  const current_environment = process.env.RAILS_ENV;

  return (
    <If condition={current_environment !== 'ui_test'}>
      <CookieConsent
        buttonText={t('cookieconsent.dismiss')}
        cookieName="cookieConsent"
        style={{ background: 'rgba(0, 33, 93, 0.95)' }}
        buttonClasses="btn btn-primary"
        buttonStyle={{ background: 'var(--primary)', color: 'var(--white)', padding: '1.1rem 2.4rem', borderRadius: '.6rem' }}
      >
        {t('cookieconsent.message')}
        {' '}
        <a aria-label="learn more about cookies" tabIndex={0} href="cookie_policy" rel="noopener noreferrer nofollow" target="_blank">
          {t('cookieconsent.link')}
        </a>
      </CookieConsent>
    </If>
  );
};

const CookieConsentComponentWrapper: FC = () => <CookieConsentComponent />;

export default CookieConsentComponentWrapper;
